module.exports = __webpack_public_path__ + "img/ltkparties-4x.7a2a590.jpg";